var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useContext } from 'react';
import { ComponentContext } from '../Context/ComponentContext';
import { pickUserAttribute } from '../Models/UsageTelemetry';
import { useUser } from './useUser';
export function useUsageTelemetry() {
    const { usageClient, telemetryContext } = useContext(ComponentContext);
    const user = useUser();
    const initializeUsage = () => __awaiter(this, void 0, void 0, function* () {
        const userParams = (telemetryContext === null || telemetryContext === void 0 ? void 0 : telemetryContext.usageUser) || {};
        if (usageClient) {
            telemetryContext === null || telemetryContext === void 0 ? void 0 : telemetryContext.setUsageConfig(usageClient === null || usageClient === void 0 ? void 0 : usageClient.getUsageConfig());
        }
        if (user && usageClient) {
            //After the user object is initialized, we can request the usage apis
            const usageUserId = yield (usageClient === null || usageClient === void 0 ? void 0 : usageClient.getUsageUserId());
            const usageUser = pickUserAttribute(Object.assign(Object.assign({}, userParams), { usageUserId }));
            telemetryContext === null || telemetryContext === void 0 ? void 0 : telemetryContext.setUsageUser(usageUser);
        }
    });
    useEffect(() => {
        initializeUsage();
        // eslint-disable-next-line
    }, [user, usageClient]); // Prettier introduces the local initializeUsage which re-renders always
}
//# sourceMappingURL=useUsageTelemetry.js.map